import React from 'react';
import { Play, Eye } from 'lucide-react';
import { contentShowcase } from '../mock';

const ContentShowcase = () => {
  return (
    <section className="py-20 bg-[#0F172A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Content That <span className="text-[#22C55E]">Converts</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            High-performing content that drives engagement and sales
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {contentShowcase.map((content, index) => (
            <div 
              key={content.id}
              className="group relative aspect-[9/16] rounded-xl overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-105 animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Thumbnail */}
              <img 
                src={content.thumbnail} 
                alt={`Content ${content.id}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F0D]/90 via-[#0A0F0D]/40 to-transparent"></div>
              
              {/* Hover Green Overlay */}
              <div className="absolute inset-0 bg-[#22C55E]/0 group-hover:bg-[#22C55E]/20 transition-all duration-300"></div>
              
              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-[#22C55E]/80 flex items-center justify-center group-hover:bg-[#22C55E] group-hover:scale-110 transition-all duration-300 shadow-lg shadow-[#22C55E]/50">
                  <Play className="h-8 w-8 text-white fill-white ml-1" />
                </div>
              </div>
              
              {/* Stats */}
              <div className="absolute bottom-0 left-0 right-0 p-4 space-y-2">
                <div className="flex items-center gap-2 text-white">
                  <Eye className="h-4 w-4 text-[#22C55E]" />
                  <span className="text-sm font-semibold">{content.views} views</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex-1 h-1 bg-white/20 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-[#22C55E] rounded-full"
                      style={{ width: `${parseFloat(content.engagement) * 10}%` }}
                    ></div>
                  </div>
                  <span className="text-[#22C55E] text-xs font-semibold">{content.engagement}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="text-[#22C55E] font-semibold hover:text-[#4ADE80] transition-colors duration-300 text-lg group">
            View Full Portfolio
            <span className="inline-block ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContentShowcase;